/**
 * Update donor details
 */
import Vue from 'vue';
import firebase from '../../firebase';
import { getParameterByName } from "../../helpers";

const state = {
    update_details: {
        email: null,
        title: null,
        firstname: null,
        lastname: null,
        phone: null,
        address: null,
        state: null,
        city: null,
        postalcode: null,
        country: null,
        isProcessing: false
    }
}

const getters = {
    update_details: state => state.update_details,
}

const mutations = {
    mutate_firebase_user: (state, user) => {
        Object.assign(state.update_details, user)
    },
    updateDetail: (state, { field, value }) => {
        Vue.set(state.update_details, field, value);
    },
}

const actions = {
    create_firebase_record_from_emailaddress: (state) => {
        return new Promise((resolve, reject) => {
            const email = state.getters.update_details.email;
            console.log(`UpdateDetails.CreateFirebaseRecord: ${email}`);
            firebase.database.ref('pending-details').push({
                public: {
                    email,
                    timestamp: new Date().toISOString()
                }
            }, (error) => {
                if (error) {
                    console.error(error);
                    reject(error)
                } else {
                    resolve()
                }
            })
        })
    },

    get_data_from_email_link: function (context) {
        return new Promise((resolve, reject) => {
            let n = getParameterByName("n");

            let decoden = "?" + window.atob(n);
            console.log("decodeq", decoden);
            let id = getParameterByName("id", decoden);
            let token = getParameterByName("token", decoden);
            if (id && token) {
                context.commit('updateDetail', {
                    field: "key",
                    value: id
                })
                context.commit('updateDetail', {
                    field: "token",
                    value: token
                })
                //firebase.database.ref('pending-details').child(context.getters.update_details.id).orderByChild('token').equalTo(context.getters.update_details.token).once('value', function (snapshot) {
                console.log('context.getters.update_details.key', context.getters.update_details.key)
                firebase.database.ref('pending-details').child(context.getters.update_details.key).child('public').once('value', function (snapshot) {
                    if (snapshot.exists()) {
                        let s = snapshot.val();
                        console.log(s);
                        context.commit('mutate_firebase_user', s)
                        resolve(true);
                    }
                    else {
                        console.log("empty", snapshot.val());
                        resolve(false);
                    }
                }, function (error) {
                    console.log("get_firebase_data_from_quertstring_id error", error)
                    reject(error)
                })
            }
            else {
                resolve(false);
            }
        })
    },

    update_new_details_to_firebase: function (context) {
        // TODO The move must be done by a trigger because everybody can write in update-details
        return new Promise((resolve, reject) => {
            firebase.database.ref('pending-details').child(context.getters.update_details.key).child('public').update(
                {
                    address: context.getters.update_details.address,
                    city: context.getters.update_details.city,
                    country: context.getters.update_details.country,
                    state: context.getters.update_details.state,
                    postalcode: context.getters.update_details.postalcode,
                    firstname: context.getters.update_details.firstname,
                    lastname: context.getters.update_details.lastname,
                    phone: context.getters.update_details.phone,
                    title: context.getters.update_details.title,
                    token: context.getters.update_details.token,
                    isChanged: true
                }
            );
        });
    },
    update_details_checkout({ dispatch, state, commit }) {
        state.update_details.isProcessing = true
        console.log('update_details_checkout', state)
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.CLOUDFUNCTION + '/updatedetailscheckout', {
                email: state.update_details.email,
                custRef: state.update_details.key
            }).then(response => {
                console.log("update_details_checkout", response)
                state.update_details.isProcessing = false
                // commit("updateDonation", {field : 'method', value: response.body.method});
                // commit("updateDonation", {field : 'url', value: response.body.url});
                resolve(response)
            }, error => {
                console.error("update_details_checkout", error)
                state.update_details.isProcessing = false
                reject(error)
            });
        })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/update_details.js